import React from "react";
import { Icon } from "antd";

const TENDENCIA_ESTILO = {
    up: { color: "#16a34a", icon: "arrow-up" },
    down: { color: "#dc2626", icon: "arrow-down" },
    flat: { color: "#64748b", icon: "arrow-right" },
};

// Tarjeta horizontal: icono a la izquierda y, a la derecha, etiqueta, valor
// y tendencia. Usa clases "kpi-tile*" propias: las "kpi-card*" son globales
// y las comparten los demas dashboards, cambiarlas aqui los afectaria.
export default function KpiCard(props) {
    const estiloTendencia = TENDENCIA_ESTILO[props.tendenciaDireccion] || TENDENCIA_ESTILO.flat;

    return (
        <div className="kpi-tile">
            <div className="kpi-tile-icon" style={{ backgroundColor: props.iconBackground, color: props.iconColor }}>
                <Icon type={props.icon} />
            </div>
            <div className="kpi-tile-body">
                <div className="kpi-tile-label">{props.label}</div>
                <div className="kpi-tile-value">{props.value}</div>
                <div className="kpi-tile-trend">
                    <span className="kpi-tile-trend-value" style={{ color: estiloTendencia.color }}>
                        <Icon type={estiloTendencia.icon} /> {props.tendenciaValor}
                    </span>
                    <span className="kpi-tile-trend-text">{props.tendenciaTexto}</span>
                </div>
            </div>
        </div>
    );
}
